import axios from 'axios';

import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import {URL} from '../root';

const FUNCTION_CODE = 'CREATE_PROJECT';

export async function createProject(token: string, payload: Record<string, unknown>) {
    try {
        const response = await axios({
            method: 'post',
            url: `${URL}/projects/`,
            data: payload,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${token}`
            }
        });

        return response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la création du projet',
            error: error
        });
    }
}
